import React from 'react';

const Section8 = ({ imgWebp, imgJpg, videoSrc, imgAlt, title, subtitle, desc }) => {
  return (
    <section className="section-8">

      <div className='container'>
        <div className='other-row content mb-5'>
            <div className='col col-100 text-center'>
                <h3 className='title'>Simple, Guided Installation Process</h3>
                <p className='desc mw-100'>Get the right system for your home in just a few quick steps. We'll confirm compatibility before installation so there are no surprises.</p>
            </div>
        </div>
        <div className='grid-2'>
            <div className='item'>
                <div className='step'>Step 1</div>
                <h4>Choose Your System</h4>
                <p className='desc w-100 mw-100'>Select the system that suits your needs, whether it's a full home filtration setup or an under-sink solution.</p>
            </div>
            <div className='item'>
                <div className='step'>Step 2</div>
                <h4>Tell Us About Your Property</h4>
                <p className='desc w-100 mw-100'>Answer a few quick questions about your home, water source, and location so we can assess compatibility.</p>
            </div>
            <div className='item'>
                <div className='step'>Step 3</div>
                <h4>Upload Photos (Optional but Recommended)</h4>
                <p className='desc w-100 mw-100'>Share photos of your water meter or installation area to help us fast-track approval and avoid delays.</p>
            </div>
            <div className='item'>
                <div className='step'>Step 4</div>
                <h4>Secure Your Installation</h4>
                <p className='desc w-100 mw-100'>Lock in your system with a refundable deposit while our team reviews your details. If installation isn't suitable, you'll receive a full refund.</p>
            </div>
        </div>
      </div>

    </section>
  )
}

export default Section8;